export default "__VITE_ASSET__fe3dc4b3__"